var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImpetus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "230px",
    height: "40px",
    viewBox: "0 0 230 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M4.3 2.7 L10.5 2.7 10.5 37.7 4.3 37.7 Z",
    fill: "#414141",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-1",
    d: "M19.8 2.7 L26.4 2.7 37 19.3 47.7 2.7 54.2 2.7 54.2 37.7 48.1 37.7 48.1 12.6 37 29.1 36.8 29.1 25.9 12.7 25.9 37.7 19.8 37.7 Z",
    fill: "#414141",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M76.5 20.9 C81.1 20.9 84 18.3 84 14.7 L84 14.6 C84 10.5 81.1 8.4 76.5 8.4 L69.4 8.4 69.4 21 76.5 21 Z M63.2 2.7 L77 2.7 C85.2 2.7 90.3 7.3 90.3 14.4 L90.3 14.5 C90.3 22.3 84 26.4 76.3 26.4 L69.4 26.4 69.4 37.6 63.3 37.6 63.3 2.7 Z",
    fill: "#414141",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M138.7 8.4 L127.6 8.4 127.6 2.7 155.9 2.7 155.9 8.4 144.9 8.4 144.9 37.7 138.7 37.7 Z",
    fill: "#414141",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    d: "M161.9 22.9 L161.9 2.7 168 2.7 168 22.6 C168 29.1 171.3 32.5 176.8 32.5 182.2 32.5 185.6 29.3 185.6 22.8 L185.6 2.7 191.7 2.7 191.7 22.5 C191.7 32.9 185.8 38.2 176.7 38.2 167.7 38.3 161.9 33 161.9 22.9",
    fill: "#414141",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    d: "M197.9 32.6 L201.6 28.2 C204.9 31.1 208.3 32.7 212.6 32.7 216.4 32.7 218.8 30.9 218.8 28.3 L218.8 28.2 C218.8 25.7 217.4 24.4 210.9 22.9 203.5 21.1 199.3 18.9 199.3 12.5 L199.3 12.4 C199.3 6.4 204.3 2.3 211.2 2.3 216.3 2.3 220.3 3.8 223.9 6.7 L220.6 11.3 C217.5 9 214.3 7.7 211.1 7.7 207.5 7.7 205.4 9.5 205.4 11.8 L205.4 11.9 C205.4 14.6 207 15.8 213.7 17.4 221.1 19.2 224.9 21.8 224.9 27.6 L224.9 27.7 C224.9 34.2 219.8 38.1 212.4 38.1 207.2 38.2 202.1 36.4 197.9 32.6",
    fill: "#414141",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    d: "M122.8 5.5 C122.8 7 121.4 8.2 119.6 8.2 L99.8 8.2 C98 8.2 96.6 7 96.6 5.5 96.6 4 98 2.8 99.8 2.8 L119.5 2.8 C121.3 2.7 122.8 4 122.8 5.5",
    fill: "#414141",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    d: "M122.8 35 C122.8 36.5 121.4 37.7 119.6 37.7 L99.8 37.7 C98 37.7 96.6 36.5 96.6 35 96.6 33.5 98 32.3 99.8 32.3 L119.5 32.3 C121.3 32.2 122.8 33.5 122.8 35",
    fill: "#414141",
    fillOpacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    d: "M122.8 20.2 C122.8 21.7 121.4 22.9 119.6 22.9 L99.8 22.9 C98 22.9 96.6 21.7 96.6 20.2 96.6 18.7 98 17.5 99.8 17.5 L119.5 17.5 C121.3 17.5 122.8 18.7 122.8 20.2",
    fill: "#414141",
    fillOpacity: 1,
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpetus);
export default __webpack_public_path__ + "static/media/impetus.7d8f85f778a37c1fc00c835c636ed2fa.svg";
export { ForwardRef as ReactComponent };